import React from 'react';
import { connect } from "react-redux";
import {setWallsLockMode} from "../../../../../actions/sqftMenuFunctions";

const WallsLockModeButton = (props) => {
  const {isWallsLockMode, setWallsLockMode} = props;

  const handleButtonClick = () => {
    setWallsLockMode(!isWallsLockMode);
  };

  return (
    <div className="ui-button-block">
      <button className={"button--rounded button--icon-lock-40-white " + (isWallsLockMode ? "button-active" : null)}
              onClick={handleButtonClick}>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => ({
  isWallsLockMode: store.sqftMenuState.isWallsLockMode,
});

const mapDispatchToProps = {
  setWallsLockMode
};


export default connect(mapStateToProps, mapDispatchToProps)(WallsLockModeButton);
